import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useIsAuthenticated } from '@azure/msal-react';
import { Box, Image } from '@chakra-ui/react';
export const IssuerBanner = () => {
    const isAuthenticated = useIsAuthenticated();
    if (!isAuthenticated) {
        return null;
    }
    return (_jsxs(Box, { position: "relative", justifyContent: "center", display: "flex", bg: "#3698c7", children: [_jsx(Box, { position: "absolute", color: "white", fontSize: "20px", top: "50%", left: "50%", transform: "translate(-50%, -50%) rotate(-30deg)", children: "PLACEHOLDER" }), _jsx(Image, { maxH: '125px', alt: "Your Issuer", src: "https://wwwtest.mysgi.ca/images/banners/0166.jpeg" })] }));
};
